"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GALLERY_ITEM_TYPE = void 0;
Object.defineProperty(exports, "GALLERY_MAX_THUMBNAIL_COUNT", {
  enumerable: true,
  get: function get() {
    return _withContainer.GALLERY_MAX_THUMBNAIL_COUNT;
  }
});
exports.Gallery = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Modal = require("b2b-components/theme/components/Modal");
var _device = require("b2b-components/utils/device");
var _withContainer = require("../withContainer");
var _Body = require("./Body");
var _MobileBody = require("./MobileBody");
var _PreviewBody = require("./PreviewBody");
require("b2b-components/core/assets/vendor/magic360/magic360.css");
require("b2b-components/core/assets/vendor/magiczoom/magiczoom.css");
require("./Gallery.scss");
var _excluded = ["currentItemIndex", "currentPreviewItemIndex", "onItemChange", "onPreviewItemChange", "onPreviewItemClick", "isModalOpened", "onModalClose", "onModalKeyDown", "deviceType", "image360", "images", "manufacturerLink", "manufacturerLogoUrl", "maxThumbnailCount", "text"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0, _defineProperty2["default"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
var GALLERY_ITEM_TYPE = /*#__PURE__*/function (GALLERY_ITEM_TYPE) {
  GALLERY_ITEM_TYPE["fallback"] = "fallback";
  GALLERY_ITEM_TYPE["image360"] = "image360";
  GALLERY_ITEM_TYPE["image"] = "image";
  GALLERY_ITEM_TYPE["more"] = "more";
  GALLERY_ITEM_TYPE["video"] = "video";
  return GALLERY_ITEM_TYPE;
}(GALLERY_ITEM_TYPE || {});
exports.GALLERY_ITEM_TYPE = GALLERY_ITEM_TYPE;
var Gallery = function Gallery(_ref) {
  var currentItemIndex = _ref.currentItemIndex,
    currentPreviewItemIndex = _ref.currentPreviewItemIndex,
    onItemChange = _ref.onItemChange,
    onPreviewItemChange = _ref.onPreviewItemChange,
    onPreviewItemClick = _ref.onPreviewItemClick,
    isModalOpened = _ref.isModalOpened,
    onModalClose = _ref.onModalClose,
    onModalKeyDown = _ref.onModalKeyDown,
    deviceType = _ref.deviceType,
    _ref$image = _ref.image360,
    image360 = _ref$image === void 0 ? null : _ref$image,
    _ref$images = _ref.images,
    images = _ref$images === void 0 ? null : _ref$images,
    _ref$manufacturerLink = _ref.manufacturerLink,
    manufacturerLink = _ref$manufacturerLink === void 0 ? null : _ref$manufacturerLink,
    _ref$manufacturerLogo = _ref.manufacturerLogoUrl,
    manufacturerLogoUrl = _ref$manufacturerLogo === void 0 ? null : _ref$manufacturerLogo,
    _ref$maxThumbnailCoun = _ref.maxThumbnailCount,
    maxThumbnailCount = _ref$maxThumbnailCoun === void 0 ? _withContainer.GALLERY_MAX_THUMBNAIL_COUNT : _ref$maxThumbnailCoun,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? {
      menuMobileImageLink: '',
      menuMobileVideoLink: '',
      modalAriaLabel: '',
      modalCloseLabel: '',
      spinHint: '',
      spinHintMobile: '',
      zoomHint: '',
      zoomHintMobile: ''
    } : _ref$text,
    restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var modalAriaLabel = text.modalAriaLabel,
    modalCloseLabel = text.modalCloseLabel;
  var commonProps = _objectSpread(_objectSpread({}, restProps), {}, {
    deviceType: deviceType,
    image360: image360,
    images: images,
    manufacturerLink: manufacturerLink,
    manufacturerLogoUrl: manufacturerLogoUrl,
    maxThumbnailCount: maxThumbnailCount,
    text: text
  });
  var renderModalBody = function renderModalBody() {
    if ((0, _device.isMobile)(deviceType)) {
      return /*#__PURE__*/_react["default"].createElement(_MobileBody.MobileBody, (0, _extends2["default"])({}, commonProps, {
        currentItemIndex: currentItemIndex,
        onItemChange: onItemChange
      }));
    }
    return /*#__PURE__*/_react["default"].createElement(_Body.Body, (0, _extends2["default"])({}, commonProps, {
      currentItemIndex: currentItemIndex,
      onItemChange: onItemChange
    }));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Gallery"
  }, /*#__PURE__*/_react["default"].createElement(_PreviewBody.PreviewBody, (0, _extends2["default"])({}, commonProps, {
    currentItemIndex: currentPreviewItemIndex || 0,
    onItemChange: onPreviewItemChange,
    onItemClick: onPreviewItemClick
  })), /*#__PURE__*/_react["default"].createElement(_Modal.Modal, {
    animationType: _Modal.MODAL_ANIMATION_TYPE.fade,
    className: "cds-Gallery-Modal",
    content: renderModalBody,
    isOpen: isModalOpened,
    onCloseModal: onModalClose,
    onKeyDown: onModalKeyDown,
    text: {
      ariaLabel: modalAriaLabel,
      ariaCloseModal: modalCloseLabel
    },
    type: _Modal.MODAL_TYPE.fullscreen
  }));
};
exports.Gallery = Gallery;
Gallery.config = {
  galleryItemType: GALLERY_ITEM_TYPE,
  maxThumbnailCount: _withContainer.GALLERY_MAX_THUMBNAIL_COUNT
};